const SUPPORT_FORM_URL = 'https://tally.so/r/D4qNMp';

export default function buildSupportFormUrl({ course, clientEmail } = {}) {
  const params = new URLSearchParams();
  if (clientEmail) params.set('email', clientEmail);
  if (course?.client_id) params.set('client_id', course.client_id);
  if (course?.id) params.set('course_id', course.id);
  if (course?.fixer_id) params.set('fixer_id', course.fixer_id);

  const query = params.toString();
  return query ? `${SUPPORT_FORM_URL}?${query}` : SUPPORT_FORM_URL;
}
